import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OpenModal, setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { ConvertErrorArrayToString, transactionTypesOptions, transactions_type } from "../../Services/Common";
import { setToastData } from "../../Store/reducers/Toast";
import moment from "moment";
import Pagination from "../../Services/Pagination";
import DatePicker from "react-date-picker";
import * as XLSX from "xlsx";
import Modal from "../../Services/Modal";
const SuperAdminTransList = () => {
    const dispatch = useDispatch();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationData, setPaginationData] = useState({ total: 0, per_page: 20 });
    const [transactionList, setTransactionList] = useState([]);
    const [showFilter, setShowFilter] = useState(true);
    const [ReceiptViewPopup, setReceiptViewPopup] = useState(false);
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
        div_id: userData.role_slug === "super_admin" ? 0 : userData.user_div,
        transaction_type: 'all',
        fromdate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        todate: moment().format('YYYY-MM-DD')
    });
    const filterHandler = (key, value) => {
        setFilter({ ...filter, [key]: value });
    }
    useEffect(() => {
        dispatch(setPageTitle('Transactions'));
        dispatch(setMainLoading(true));
        let promiseArray = [];
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
        }
        if (promiseArray.length > 0) {
            Promise.all(promiseArray)
                .then((response) => {
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                }).finally(() => {
                    dispatch(setMainLoading(false));
                })
        }
        else {
            fetchTransactionList();
        }
    }, [accessToken, dispatch]);
    const filteredDivList = useMemo(() => {
        let tempL = [];
        let orgId = parseInt(filter.org_id);
        for (let div of divList) {
            if (parseInt(div.org_id) === orgId) {
                tempL.push(div);
            }
        }
        return tempL;
    }, [filter.org_id, divList]);
    const fetchTransactionList = (pageNo = 0) => {
        dispatch(setMainLoading(true));
        let postData = {
            ...filter
        }
        if (pageNo > 0) {
            postData.page = pageNo
            postData.perPage = paginationData.per_page
        }
        PostAxios(`payments/transaction-list`, postData, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setPaginationData({ total: data.totalRecords, per_page: data.perPage });
                    setTransactionList(data.data || []);
                }
                else {
                    setPaginationData({ total: 0, per_page: 20 });
                    setTransactionList([]);
                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err);
                setTransactionList([]);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const [exportData,setExportData] = useState('');
    const exportWrapper = useRef(null);
    const exportReport = () => {
        dispatch(setMainLoading(true));
        setExportData('');
        let postData = {
            ...filter
        }
        PostAxios(`payments/export-transactions`, postData, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setExportData(data.data);
                }
                else {
                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const exportToExcel = () =>{
        var wb = XLSX.utils.table_to_book(exportWrapper.current, {
			sheet: "Transactions",
		});
        
		XLSX.writeFile(wb, `${filter.transaction_type}-transactions-${moment().format('DD-MM-YYYY-hh-mma')}.xlsx`, {
			cellStyles: true,
		});
    }
    useEffect(()=>{
        if(exportData !== ""){
            exportToExcel();
        }
    },[exportData]);
    const viewReceipt = async (rc_id)=>{
        setReceiptViewPopup(true);
        dispatch(setMainLoading(true));
        let formData = new FormData();
        formData.append('rc_id',rc_id);
        formData.append('token',accessToken);
        try{
            const res = PostAxios(`${process.env.REACT_APP_API_URL}payments/view-receipt`, {
                rc_id
            },accessToken,{"accept":'application/pdf'}).then(async (res)=>{
                console.log(res);
                const blob = await res.blob();
                console.log(blob);
                const urlObject = URL.createObjectURL(blob, { type: 'application/pdf' });
                document.querySelector('iframe').setAttribute("src", urlObject);
                dispatch(OpenModal());
            }).catch(err=>{
                responseCatchFunc(dispatch,err);
            });
        }catch(err){
            console.log(err);
        }
    }
    return (
        <div className="main-form-sec">
            <div className="top-right-btn p-0">
                <button className="btn-blue btn br-0" onClick={()=>{exportReport()}}>
                    Export Report
                </button>
            </div>
            <div className="top-reports-filter">
                <div className={`right-filter-sec`}>
                    <button className="filter-toggle" onClick={() => {
                        setShowFilter(!showFilter);
                    }}>
                        <i className="fa-solid fa-filter"></i>
                    </button>
                    <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
                        {
                            userData.role_slug === "super_admin" &&
                            <div className="report-filter-field">
                                <label className="select-input-outer">Organization</label>
                                <div className="static-items-outer">
                                    <select
                                        id="org_id"
                                        name="org_id"
                                        className="select-input"
                                        value={filter.org_id}
                                        onChange={(e) => setFilter({ ...filter, "org_id": e.target.value, div_id: 0 })}
                                    >
                                        <option value='0'>Choose Organization</option>
                                        {
                                            orgList.length > 0 && orgList.map((item, index) => <option key={`org-${index}`} value={item.ID}>{item.short_name}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                        {
                            (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                            <div className="report-filter-field">
                                <label className="select-input-outer">Division</label>
                                <div className="static-items-outer">
                                    <select
                                        id="div_id"
                                        name="div_id"
                                        className="select-input"
                                        value={filter.div_id}
                                        onChange={(e) => filterHandler("div_id", e.target.value)}
                                    >
                                        <option value='0'>Choose Division</option>
                                        {
                                            filteredDivList.length > 0 && filteredDivList.map((item, index) => <option key={`div-list-${index}`} value={item.ID}>{item.division_name} {`(${item.division_number})`}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                        <div className="report-filter-field">
                            <label className="select-input-outer">Transaction Type</label>
                            <div className="static-items-outer">
                                <select
                                    id="transaction_type"
                                    name="transaction_type"
                                    className="select-input"
                                    value={filter.transaction_type}
                                    onChange={(e) => filterHandler("transaction_type", e.target.value)}
                                >
                                    <option value='all'>All</option>
                                    {
                                        transactionTypesOptions.map((item, index) => <option key={`tto-${index}`} value={item.id}>{item.value}</option>)
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="report-filter-field multi-select-reports">
                            <label className="select-input-outer" >Date From</label>
                            <DatePicker
                                className="form-input"
                                placeholder="From Date"
                                name="fromdate"
                                id="fromdate"
                                clearIcon={null}
                                format="dd-MM-y"
                                maxDate={new Date(filter.todate)}
                                onChange={(val) => {
                                    if (val) {
                                        filterHandler('fromdate', moment(val).format("YYYY-MM-DD"));
                                    }
                                }}
                                value={(filter.fromdate && new Date(filter.fromdate)) || null}
                            />
                        </div>
                        <div className="report-filter-field multi-select-reports">
                            <label className="select-input-outer" >Date To</label>
                            <DatePicker
                                className="form-input"
                                placeholder="To Date"
                                name="todate"
                                id="todate"
                                minDate={new Date(filter.fromdate)}
                                maxDate={new Date()}
                                format="dd-MM-y"
                                clearIcon={null}
                                onChange={(val) => {
                                    if (val) {
                                        filterHandler('todate', moment(val).format("YYYY-MM-DD"));
                                    }
                                }}
                                value={(filter.todate && new Date(filter.todate)) || null}
                            />
                        </div>
                        <button type="button" className="btn btn-blue ms-2" onClick={() => { setCurrentPage(1); fetchTransactionList(1); }}>Submit</button>
                    </div>
                </div>
            </div>
            <div className="table-wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th>Transaction ID</th>
                            <th>ITS</th>
                            <th>Name</th>
                            <th>Division</th>
                            <th>Type</th>
                            <th>Description</th>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>View Receipt</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            transactionList.length > 0 && transactionList.map((item, index) => {
                                return <tr key={`transaction-id-${index}-${item.ut_id}`}>
                                    <td>{(currentPage - 1) * paginationData.per_page + index + 1}</td>
                                    <td>{item.order_id}</td>
                                    <td>{item.user_its}</td>
                                    <td>{item?.mem_full_name.trim()}</td>
                                    <td>{item.div_name}</td>
                                    <td>{transactions_type[item.transaction_type]}</td>
                                    <td>{item.transaction_description}</td>
                                    <td><i className="fa-solid fa-indian-rupee-sign"></i> {item.final_amount}</td>
                                    <td>{moment(item.transaction_done_on).format('DD, MMM YYYY hh:mm A')}</td>
                                    <td>
                                        <button type="button" className="btn btn-blue btn-sm" onClick={()=>{
                                            viewReceipt(item.ut_id)
                                        }}>
                                            <i className="fa-regular fa-eye"></i>
                                        </button>
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={currentPage}
                totalCount={paginationData.total}
                pageSize={paginationData.per_page}
                onPageChange={page => {
                    setCurrentPage(page);
                    fetchTransactionList(page);
                }}
            />
            <div ref={exportWrapper} style={{display:'none'}} className="export-table-style" dangerouslySetInnerHTML={{__html:exportData}}></div>
            {
				ReceiptViewPopup === true && <Modal classList="popup-main pdf-preview-popup" style={{maxWidth:'450px'}} onClose={() => {
					setReceiptViewPopup(false);
				}}>
					<div className="pdf-viewer-wrapper" style={{ userSelect: 'none' }}>
						<div className="pdf-viewer-container" style={{width:'100%',flex:' 0 0 100%'}}>
							<>
								<iframe style={{ border: 0 }} title="Preview Document" type="application/pdf" src="" width="100%" height="95%" onLoad={() => {
									dispatch(setMainLoading(false));
								}} />
							</>
						</div>
					</div>
				</Modal>
			}
        </div>
    )
}

export default SuperAdminTransList;